// Styles

// Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css';

import 'tippy.js/dist/tippy.css';

import '@mantine/core/styles.css';

// Tailwind
import './tailwind.css';

// Global css
import './global.scss'

// Configurations
import './shared/config'

import FrontApp from 'apps/front-office/front-office-modules.json'
import router, {setApps} from 'core/react-router'
import {detectDirection} from './shared/utils'

import './shared/utils/global'

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

detectDirection()

setApps([FrontApp])

router.boot()
